import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { addInPlaceComment } from 'project/ducks/revisions';
import { DEFAULT_REQUIRED_MESSAGE } from 'common/components/form_fields';
import EntryCommentModal from 'project/components/entry_details/entry_comment_modal';

const validate = (values) => {
  if (!values.comment || !values.comment.trim()) {
    return { comment: 'Please add some text.' };
  }
}

const WrappedEntryCommentModal = reduxForm({ form: 'entry-inplace-comment-form', validate })(EntryCommentModal);

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {
  addInPlaceComment,
})(WrappedEntryCommentModal);



// WEBPACK FOOTER //
// ./project/containers/entry_comment_modal.js